import ResultType from '@/enums/finance/ResultType';
import FinanceSettlement from './FinanceSettlement';

export default class FinanceSettlementResult {
  public result: FinanceSettlement = new FinanceSettlement();

  public success: boolean = false;

  public resultType: ResultType = ResultType.Unknown;
}
